import { forIn, isArray, random } from "lodash";
import { firestore, auth, Timestamp } from "../_firebase";
import Collection from "../_collections";
import profileConstants from "../_constants/profileConstants";

const markProfileViewed = profileId => {
  //get reference to profile view collection
  const userId = auth.currentUser.uid;
  const profileViewDocRef = firestore
    .collection(Collection.PROFILE_VIEWS)
    .doc(`${userId}_${profileId}`);
  firestore
    .runTransaction(transaction => {
      return transaction.get(profileViewDocRef).then(profileViewDoc => {
        if (!profileViewDoc.exists) {
          //CREATE NEW DOC
          transaction.set(profileViewDocRef, {
            viewerId: userId,
            profileId,
            viewedAt: Timestamp.now(),
            count: 1
          });
        } else {
          let updatedCount = profileViewDoc.data().count + 1;
          transaction.update(profileViewDocRef, {
            count: updatedCount,
            viewedAt: Timestamp.now()
          });
        }
      });
    })
    .then(() => {
      console.log("Marked Profile as viewed");
    })
    .catch(error => {
      console.log("Error marking profile as viewed", error);
    });
};
const likeProfile = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.PROFILE_LIKES)
      .doc(`${userId}_${profileId}`)
      .set({
        userId,
        profileId,
        createdAt: Timestamp.now()
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};

const unlike = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.PROFILE_LIKES)
      .doc(`${userId}_${profileId}`)
      .delete()
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const expressInterest = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.INTERESTS)
      .doc(`${userId}_${profileId}`)
      .set({
        userId,
        profileId,
        createdAt: Timestamp.now()
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const cancelExpressInterest = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.INTERESTS)
      .doc(`${userId}_${profileId}`)
      .delete()
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const shortlist = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.SHORTLISTS)
      .doc(`${userId}_${profileId}`)
      .set({
        userId,
        profileId,
        createdAt: Timestamp.now()
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const removeShortlist = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.SHORTLISTS)
      .doc(`${userId}_${profileId}`)
      .delete()
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const saveProfile = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.SAVES)
      .doc(`${userId}_${profileId}`)
      .set({
        userId,
        profileId,
        createdAt: Timestamp.now()
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const removeSavedProfile = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.SAVES)
      .doc(`${userId}_${profileId}`)
      .delete()
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const addProfileToFavorite = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.FAVORITES)
      .doc(`${userId}_${profileId}`)
      .set({
        userId,
        profileId,
        createdAt: Timestamp.now()
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const removeFromFavorite = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.FAVORITES)
      .doc(`${userId}_${profileId}`)
      .delete()
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const getPartnerPreference = profileId => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.USERS)
      .doc(profileId)
      .collection(Collection.PARTNER_PREFERENCE)
      .doc(profileId)
      .get()
      .then(doc => {
        resolve(doc.data());
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const connectProfile = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.CONNECTS)
      .doc(`${userId}_${profileId}`)
      .set({
        userId,
        profileId,
        status: profileConstants.CONNECT_PENDING_STATUS,
        createdAt: Timestamp.now(),
        approvedAt: null
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const approveConnect = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.CONNECTS)
      .doc(`${profileId}_${userId}`)
      .update({
        status: profileConstants.CONNECT_APPROVED_STATUS,
        approvedAt: Timestamp.now()
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const disconnect = profileId => {
  const userId = auth.currentUser.uid;

  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.CONNECTS)
      .where("userId", "==", userId)
      .where("profileId", "==", profileId)
      .get()
      .then(results => {
        if (results.empty) {
          firestore
            .collection(Collection.CONNECTS)
            .doc(`${profileId}_${userId}`)
            .delete()
            .then(() => {
              resolve();
            })
            .catch(err => {
              console.log(err);
              reject("Please Try again later.");
            });
        } else {
          firestore
            .collection(Collection.CONNECTS)
            .doc(results.docs[0].id)
            .delete()
            .then(() => {
              resolve();
            })
            .catch(err => {
              console.log(err);
              reject("Please Try again later.");
            });
        }
      })
      .catch(err => {
        console.log(err);
        reject("Please Try again later.");
      });
  });
  return promise;
};

const getTopImages = profileId => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.USERS)
      .doc(profileId)
      .collection(Collection.GALLERY)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let images = [];
        results.forEach(result => {
          images.push({ ...result.data(), ...{ id: result.id } });
        });
        resolve(images);
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};

const getAllImages = profileId => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.USERS)
      .doc(profileId)
      .collection(Collection.GALLERY)
      .orderBy("createdAt", "desc")
      .get()
      .then(results => {
        let images = [];
        results.forEach(result => {
          images.push({ ...result.data(), ...{ id: result.id } });
        });
        resolve(images);
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const getMobile = profileId => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.USERS)
      .doc(profileId)
      .collection(Collection.PHONE_NUMBER)
      .doc(profileId)
      .get()
      .then(result => {
        resolve(result.data());
      })
      .catch(err => {
        reject("Please Try Again Later");
      });
  });
  return promise;
};
const profileService = {
  markProfileViewed,
  likeProfile,
  expressInterest,
  shortlist,
  saveProfile,
  addProfileToFavorite,
  unlike,
  cancelExpressInterest,
  removeShortlist,
  removeSavedProfile,
  removeFromFavorite,
  getPartnerPreference,
  connectProfile,
  approveConnect,
  disconnect,
  getTopImages,
  getAllImages,
  getMobile
};
export default profileService;



// WEBPACK FOOTER //
// ./src/_services/profileService.js